import { useState, useEffect } from "react";
import { Routes, Route } from "react-router-dom";
import About from "./about/About";
import BlogList from "./blog/BlogList";
import BlogDetail from "./blog/BlogDetail";
import Header from "./Header";
import Footer from "./Footer";
import ScrollToTop from "./ScrollToTop";
import { MathJaxContext } from "better-react-mathjax";
import { LangProvider } from "./i18n/LangContext";

const mathJaxConfig = {
  tex: {
    packages: { "[+]": ["boldsymbol"] },
  },
};

const mathJaxSrc =
  "https://cdn.jsdelivr.net/npm/mathjax@3/es5/tex-chtml-full.js";

export default function App() {
  const [dark, setDark] = useState(() => {
    const saved = localStorage.getItem("theme");
    if (saved) return saved === "dark";
    return window.matchMedia("(prefers-color-scheme: dark)").matches;
  });

  useEffect(() => {
    localStorage.setItem("theme", dark ? "dark" : "light");
  }, [dark]);

  return (
    <LangProvider>
    <MathJaxContext src={mathJaxSrc} config={mathJaxConfig}>
      <div className={dark ? "dark" : ""}>
        <div className="font-sans min-h-screen flex flex-col bg-white dark:bg-gray-950 text-slate-900 dark:text-slate-100 transition-colors duration-500">
          <Header dark={dark} setDark={setDark} />
          <main className="flex-grow px-6 md:px-10 lg:px-0">
            <ScrollToTop/>
            <Routes>
              {["", "/en"].map((prefix) => [
                <Route key={`${prefix}/`} path={prefix || "/"} element={<About />} />,
                <Route key={`${prefix}/blog`} path={`${prefix}/blog`} element={<BlogList />} />,
                <Route key={`${prefix}/blog/:slug`} path={`${prefix}/blog/:slug`} element={<BlogDetail />} />,
              ])}
            </Routes>
          </main>
          <Footer />
        </div>
      </div>
    </MathJaxContext>
    </LangProvider>
  );
}
